import { jsx as _jsx } from "react/jsx-runtime";
export default function ShapeRect(_ref) {
  let {
    fill,
    width,
    height,
    style
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    style: {
      width,
      height,
      background: fill,
      ...style
    }
  });
}